/**
 * Image editor component
 */
export const COMP_IMAGE_EDITOR = "ImageEditorComponent";

/**
 * Data type used to flag galleries holding color parent behaviour
 */
export const GALLERY_COLOR_PARENT = "color-parent";
/**
 * Data type used to flag galleries holding color child swatch behaviour
 */
export const GALLERY_COLOR_CHILD = "color-parent";

/**
 * Component name for swatch color parent selection behaviour
 */
export const COMP_SWATCH_COLOR_PARENT_SELECT_BEHAVIOUR = "SwatchColorParentSelectBehaviour";

export const COMP_UPLOAD_PRICING_BEHAVIOUR = "UploadPricingBehaviour";

/**
 * Component name for upload ui and behaviour
 */
export const COMP_UPLOAD_UI = "UploadComponent";

/**
 * Component name for no selection behaviour
 */
export const COMP_NO_SELECTION = "NoSelectionComponent";

/**
 * Component name for group button auto select on load behaviour
 */
export const COMP_GROUP_BTN_AUTO_SELECT = "GroupBtnAutoSelectComponent";
/**
 * Component name for group navigation during state loading.
 */
export const COMP_LOAD_STATE_NAV = "LoadStateGroupNav";

/**
 * Component name for feature where enabling a flag will auto select the same options
 * on both ears.
 */
export const COMP_MATCH_SELECTION = "MatchSelectionBehavior";

/**
 * Adds "Add Later" behaviour to upload preset image and flag design as requiring art from
 * the customer.
 */
export const COMP_ADD_LATER = "AddLaterBehaviorComponent";

/**
 * Adds warning label behavior to all galleries
 */
export const COMP_WARNINGS = "WarningsComponent";

/**
 * Component name for dom api methods
 */
export const COMP_DOM = "DomApi";

export const MAX_UPLOAD_SIZE_MB = 10; // In Megabytes
export const TEX_SIZE = 1024;

export const uploadArea = {
  left: {
    x: .5,
    y: .1,
    w: .4,
    h: .4
  },
  right: {
    x: .1,
    y: .1,
    w: .4,
    h: .4
  }
}